import * as React from 'react'
import { useMutation } from '@tanstack/react-query'
import { Alert } from '@/components/ui/alert'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { patchJSON } from '@/lib/api'

export function MemberSelfCancellationSetting({ initialEnabled }: { initialEnabled: boolean }) {
  const [enabled, setEnabled] = React.useState(initialEnabled)
  const updateSetting = useMutation({
    mutationFn: (value: boolean) =>
      patchJSON<{ renewal_settings: { member_self_cancellation_enabled?: boolean } }>(
        '/api/v1/renewal_settings',
        { renewal_settings: { member_self_cancellation_enabled: value } },
      ),
    onSuccess: (data) =>
      setEnabled(data.renewal_settings.member_self_cancellation_enabled === true),
  })

  return (
    <Card className="mt-4 max-w-2xl">
      <CardHeader className="p-4 pb-3">
        <CardTitle className="text-body font-semibold">Member self-service</CardTitle>
      </CardHeader>
      <CardContent className="p-4 pt-0">
        <div className="flex items-start gap-3">
          <Checkbox
            id="member-self-cancellation"
            checked={enabled}
            disabled={updateSetting.isPending}
            onCheckedChange={(checked) => updateSetting.mutate(checked === true)}
          />
          <div className="grid gap-1 leading-none">
            <Label htmlFor="member-self-cancellation">Allow member self-cancellation</Label>
            <p className="text-body-sm text-muted-foreground">
              Members can choose not to renew from the Member Portal.
            </p>
          </div>
        </div>
        {updateSetting.isError && <Alert className="mt-3">{updateSetting.error.message}</Alert>}
      </CardContent>
    </Card>
  )
}
